import { Component, Input, ViewChild, ViewChildren, ElementRef, QueryList, AfterContentChecked } from '@angular/core'
import { fromEvent } from 'rxjs'
import { debounceTime } from 'rxjs/operators'

@Component({
    selector: 'app-scroll-indicator',
    templateUrl: 'scroll-indicator.html'
})
export class ScrollIndicatorComponent implements AfterContentChecked {
    @Input() label: string | undefined
    @Input() useOverflowGradient = true
    @Input() heightOffset: number

    scrollableContainer: HTMLElement
    scrolledPercentage: number = 0
    overflows = false

    @ViewChildren('scrollContainer') scrollContainer: QueryList<ElementRef>
    @ViewChild('progressBar', { static: true }) progressBar: ElementRef<HTMLElement>

    constructor() {
        fromEvent(window, 'resize')
            .pipe(debounceTime(300))
            .subscribe(() => {
                this.checkForOverflow()
            })
    }

    ngAfterContentChecked(): void {
        this.checkForOverflow()
    }

    checkForOverflow() {
        const scrollContainer = this.scrollContainer?.first

        if (scrollContainer?.nativeElement) {
            if (scrollContainer.nativeElement.scrollHeight > scrollContainer.nativeElement.offsetHeight) {
                this.overflows = true
            } else {
                this.overflows = false
            }
        }
    }

    onScroll($event: Event) {
        this.scrollableContainer = $event.target as HTMLElement;

        if (this.scrollableContainer) {
            const height = this.scrollableContainer.clientHeight;
            const scrollHeight = this.scrollableContainer.scrollHeight - height;
            const scrollTop = this.scrollableContainer.scrollTop;
            this.scrolledPercentage = Math.floor(scrollTop / scrollHeight * 100);
            this.progressBar.nativeElement.style.width = this.scrolledPercentage + "%";
        }
    }

    onContentChange() {
        if (this.scrollableContainer) {
            this.scrollableContainer.scroll({
                top: 0,
                behavior: 'smooth'
            })
            this.progressBar.nativeElement.style.width = 0 + "%";
        }

        this.checkForOverflow()
     }
}
